import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { AccordionIdentityCard as AccordionIdentityCardType } from 'shell/view-models/accordion-identity-card';
import { Fragment, memo, useCallback, useState } from 'react';
import { useFormikContext } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { CancellationIdCardForm } from '../../../../pages/cancellation-id-card/cancellation';
import AccordionRegistrationIdentityCardForm from './form';

export interface AccordionIdentityCardComponentProps {
  form: AccordionIdentityCardType | undefined;
}

const AccordionIdentityCardComponent = ({
  form,
}: AccordionIdentityCardComponentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CancellationIdCardForm>();

  const onChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('identityCard', {
        ...formContext.values.identityCard,
        [key]: value,
      });
    },
    [formContext.setFieldValue, formContext.values.identityCard]
  );

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-identity-card-content"
          id="panel-identity-card-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>{"Annullamento Carta d'Identità"}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionRegistrationIdentityCardForm
            form={form}
            onChange={onChange}
            values={formContext.values.identityCard}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionIdentityCardComponent.displayName = 'Accordion cancellation identity card component';

const AccordionIdentityCard = memo(AccordionIdentityCardComponent);

export default AccordionIdentityCard;
